(function () {
  var MOBILE_MAX = 599;

  function isMobileStl() {
    return window.matchMedia('(max-width: ' + MOBILE_MAX + 'px)').matches;
  }

  function debounce(fn, ms) {
    var t;
    return function () {
      clearTimeout(t);
      t = setTimeout(fn, ms);
    };
  }

  /**
   * Third carousel slide on PDP: product-gallery-2 (0-based) or 3rd image in swiper slides.
   */
  function getThirdCarouselImageUrl() {
    var g2 = document.querySelector('.product-gallery-2 img');
    if (g2 && (g2.currentSrc || g2.src)) return g2.currentSrc || g2.src;
    var inSlides = document.querySelectorAll('.swiper-slide .product-media img');
    if (inSlides.length >= 3) {
      var img = inSlides[2];
      return img.currentSrc || img.src;
    }
    var anySlide = document.querySelectorAll('.swiper-slide img');
    if (anySlide.length >= 3) {
      var im = anySlide[2];
      return im.currentSrc || im.src;
    }
    return null;
  }

  function syncShopTheLookHero() {
    var url = getThirdCarouselImageUrl();
    document.querySelectorAll('.shop-the-look').forEach(function (shopLook) {
      if (!shopLook.querySelector('.multi-product')) return;

      if (!isMobileStl()) {
        var existing = shopLook.querySelector('.shop-the-look__hero');
        if (existing) existing.remove();
        return;
      }

      if (!url) return;

      var hero = shopLook.querySelector('.shop-the-look__hero');
      if (!hero) {
        hero = document.createElement('div');
        hero.className = 'shop-the-look__hero';
        hero.setAttribute('aria-hidden', 'true');
        shopLook.insertBefore(hero, shopLook.firstChild);
      }
      var img = hero.querySelector('img');
      if (!img) {
        img = document.createElement('img');
        img.alt = '';
        hero.appendChild(img);
      }
      var next = url;
      if (img.getAttribute('src') !== next) img.setAttribute('src', next);
    });
  }

  function patchModalButtons(modal) {
    if (!modal) return;
    modal.querySelectorAll('button:not([type])').forEach(function (btn) {
      btn.setAttribute('type', 'button');
    });
  }

  function watchShopTheLookModal() {
    var modal = document.querySelector('[data-modal="ShopTheLook"]');
    if (!modal) return;

    modal.addEventListener('submit', function (e) {
      var addBtn = e.target.querySelector('[data-add-to-cart], .stl-add-btn, .multi-product__atc');
      if (!addBtn) {
        e.preventDefault();
      }
    }, true);

    patchModalButtons(modal);

    var obs = new MutationObserver(function () {
      syncShopTheLookHero();
      patchModalButtons(modal);
    });
    obs.observe(modal, { childList: true, subtree: true });
  }

  function slideToThirdImage() {
    var sw = document.querySelector('.swiper-container');
    if (!sw || !sw.swiper) return;
    var swiper = sw.swiper;
    if (swiper.params && swiper.params.loop && typeof swiper.slideToLoop === 'function') {
      swiper.slideToLoop(2);
    } else {
      swiper.slideTo(2);
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-stl-open]');
    if (!btn) return;
    slideToThirdImage();
  });

  function boot() {
    watchShopTheLookModal();
    syncShopTheLookHero();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.addEventListener(
    'resize',
    debounce(function () {
      syncShopTheLookHero();
    }, 150)
  );

  // Mobile accordion - event delegation for dynamically loaded content
  document.addEventListener('click', function (e) {
    var chevron = e.target.closest('.multi-product__chevron');
    if (!chevron) return;
    if (window.innerWidth >= 600) return;
    e.preventDefault();
    var article = chevron.closest('.multi-product');
    if (article) article.classList.toggle('is-open');
  });
})();
